import { Product } from 'BrokerTsLib/src/enums'
import { ContractsPropertyExportForm, ContractsPropertyExportFormValues } from './ContractsPropertyExportForm'
import { ContractsExportForm } from '../carkulka/ContractsExportForm'

export const ContractsPropertyExport = () => {
  return (
    <ContractsExportForm product={Product.PropertyInsurance} />
    // <ContractsPropertyExportForm
    //   onSubmit={(values: ContractsPropertyExportFormValues) => {
    //     console.log(values)
    //   }}
    // />
  )
}
